import { toArray } from 'lodash'
import { mapLanguage } from 'Lib/i18nMiddleware'
import { SET_LANGUAGE } from './config'

export const PROMO_BUNDLES_FETCH_LIST_REQUEST =
  'PROMO_BUNDLES::FETCH_LIST_REQUEST'
export const PROMO_BUNDLES_FETCH_LIST_FAIL = 'PROMO_BUNDLES::FETCH_LIST_FAIL'
export const PROMO_BUNDLES_FETCH_LIST_SUCCESS =
  'PROMO_BUNDLES::FETCH_LIST_SUCCESS'

const initialState = { list: [], default: [], fetching: false }

export const fetchBenefitList = () => ({
  type: PROMO_BUNDLES_FETCH_LIST_REQUEST,
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PROMO_BUNDLES_FETCH_LIST_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }
    case PROMO_BUNDLES_FETCH_LIST_SUCCESS: {
      return {
        ...state,
        list: toArray(action.data).map(data => ({
          ...data,
          bundle: mapLanguage(action.lang)(data.bundle),
        })),
        default: toArray(action.data),
        fetching: false,
      }
    }
    case PROMO_BUNDLES_FETCH_LIST_FAIL: {
      return {
        ...state,
        list: [],
        fetching: false,
      }
    }
    case SET_LANGUAGE: {
      return {
        ...state,
        list: state.default.map(data => ({
          ...data,
          bundle: mapLanguage(action.payload.lang)(data.bundle),
        })),
      }
    }
    default:
      return state
  }
}

export default reducer
